// Mock data for Tek Solutions and Consultants

export const companyInfo = {
  name: "Tek Solutions and Consultants",
  tagline: "Precision Engineered Vulcanizing Solutions",
  email: "tek.solutions.consultants@gmail.com",
  phone: "+91 9482154063,\xA0+91 8123625379",
  address: "Industrial Area, City, State, India"
};

export const aboutContent = {
  title: "About Us",
  description: "Tek Solutions and Consultants is an OEM of tailor-made vulcanizing machines and related accessories. With 30+ years of expertise in precision engineering, we design and supply high-quality vulcanizing solutions to industries worldwide. Our commitment to customization, durability, and reliability sets us apart in the industry. We work closely with our clients to understand their specific requirements and deliver machines that exceed expectations."
};

export const products = [
{
  id: 1,
  title: "Custom Vulcanizing Machines",
  description: "Tailor-made vulcanizing machines designed to meet your specific industrial requirements"
},
{
  id: 2,
  title: "Heating Systems",
  description: "Advanced heating solutions for optimal vulcanization processes"
},
{
  id: 3,
  title: "Pressure Systems",
  description: "Precision-controlled pressure systems for consistent results"
},
{
  id: 4,
  title: "Control Panels",
  description: "Intelligent control systems for automated operations"
},
{
  id: 5,
  title: "Accessories & Parts",
  description: "Complete range of accessories and replacement parts"
},
{
  id: 6,
  title: "Maintenance Services",
  description: "Expert maintenance and support services for optimal performance"
}];


export const customers = [
"Mining Industry",
"Cement Manufacturing",
"Steel Plants",
"Material Handling",
"Conveyor Systems",
"Power Generation"];

export const customerLogos = [
{
  id: 1,
  name: "JSW Infrastructure",
  logo: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/aol5dck0_2409b0_6b1a7ddd6b5a4b57a65ef99569d39ee1~mv2.jpeg"
},
{
  id: 2,
  name: "Jindal Stainless",
  logo: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/l1rultt7_download_jfif.jpeg"
},
{
  id: 3,
  name: "Kirloskar",
  logo: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/9rq4de4j_2409b0_84770312166b4adaa51b76640b5fa7bc~mv2.jpeg"
},
{
  id: 4,
  name: "JSW Cement",
  logo: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/mvm6wjq6_2409b0_8db23afc6f42490e855a0d9dad6880f3~mv2.jpeg"
},
{
  id: 5,
  name: "Adani Ports and Logistics",
  logo: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/ezx1tfa8_2409b0_c9cd74b5e15b478887067f6f24aeb2ad~mv2.jpeg"
},
{
  id: 6,
  name: "Zuari Cement",
  logo: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/ph5ot9km_2409b0_0b8fa6eb08754531a06c87e89b740116~mv2.jpeg"
},
{
  id: 7,
  name: "Aditya Birla Grasim",
  logo: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/4vpoa03c_2409b0_f2e1e87f2c254866b24d113d250f2bd5~mv2.jpeg"
},
{
  id: 8,
  name: "HeidelbergCement",
  logo: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/x1jcly36_2409b0_7a7f9165417f47c7838e067d0e53c5e1~mv2.jpeg"
},
{
  id: 9,
  name: "L&T",
  logo: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/jsd80y6s_L-T.jpeg"
},
{
  id: 10,
  name: "Shree Cement",
  logo: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/qv9uycuk_2409b0_b3e9c31f0ede4b559368012b85df1d24~mv2.jpeg"
},
{
  id: 11,
  name: "JSW Steel",
  logo: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/54l6w9p4_2409b0_b092b7a1b2214e2eb717567a8679a398~mv2.jpeg"
},
{
  id: 12,
  name: "NTPC",
  logo: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/ngb47mql_2409b0_da94ccdf6eb045b385a0df0d4431dc62~mv2.jpeg"
},
{
  id: 13,
  name: "Dalmia Bharat Cement",
  logo: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/qdgexhpa_2409b0_4dda2e77342e4991bac3feb807ef81a6~mv2.jpeg"
},
{
  id: 14,
  name: "UltraTech Cement",
  logo: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/8l6qjkgx_3d-corporate-logo-full.jpeg"
},
{
  id: 15,
  name: "Patel",
  logo: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/8qpkajns_1657558108511_jfif%20%281%29.jpeg"
}];



export const technicalComponents = [
{
  id: 1,
  name: "Heating Systems",
  description: "Advanced thermal control systems ensuring uniform heat distribution across the vulcanization surface"
},
{
  id: 2,
  name: "Pressure Systems",
  description: "Precision-engineered hydraulic and pneumatic systems for consistent pressure application"
},
{
  id: 3,
  name: "Control Panels",
  description: "Intelligent automation systems with temperature and pressure monitoring capabilities"
},
{
  id: 4,
  name: "Structural Frames",
  description: "Robust steel frameworks designed to withstand industrial operational demands"
}];

export const machineGallery = [
{
  id: 1,
  title: "Vulcanizing Machine",
  image: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/fk0ane5t_2409b0_f90f472691ad428c9c7e7722fb66987f~mv2.jpeg"
},
{
  id: 2,
  title: "Fastener Component",
  image: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/rilqvn18_WhatsApp%20Image%202026-03-17%20at%2020.36.28.jpeg"
},
{
  id: 3,
  title: "Hydraulic Manifold",
  image: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/mcvahoe2_WhatsApp%20Image%202026-03-16%20at%2017.14.02.jpeg"
},
{
  id: 4,
  title: "Pressure Gauge",
  image: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/r70iwnad_WhatsApp%20Image%202026-03-16%20at%2017.09.45.jpeg"
},
{
  id: 5,
  title: "Heating Plate System",
  image: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/bj89sfte_WhatsApp%20Image%202026-03-16%20at%2016.42.05.jpeg"
},
{
  id: 6,
  title: "Control Panel",
  image: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/ep3764v6_WhatsApp%20Image%202026-03-16%20at%2016.42.59.jpeg"
},
{
  id: 7,
  title: "Machine Frame Structure",
  image: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/mtegob9e_WhatsApp%20Image%202026-03-16%20at%2016.43.30.jpeg"
},
{
  id: 8,
  title: "Clamp Bracket",
  image: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/yb2ek44o_WhatsApp%20Image%202026-03-16%20at%2016.46.48.jpeg"
},
{
  id: 9,
  title: "Heating Plate Installation",
  image: "https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/pl2kzkp8_WhatsApp%20Image%202026-03-16%20at%2016.40.38.jpeg"
}];



export const mockQuoteSubmission = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Quote request submitted:", formData);
      resolve({ success: true, message: "Quote request received successfully!" });
    }, 1000);
  });
};